import React from 'react';

import { Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import grandma5 from '../assets/grandma5.jpg';
import grandma5M from '../assets/grandma5M.jpg';
import computerLady5 from '../assets/computerLady5.jpg';
import computerLady5M from '../assets/computerLady5M.jpg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '6.5rem',
    width: '100vw',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2.5rem'
    }
  },
  img: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}));

const PhotoCollage4 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const { ref, inView } = useInView({ triggerOnce: true });

  const renderer = (
    <>
      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 2, delay: 0.4 } }}
        src={matchesSM ? computerLady5M : computerLady5}
        alt="lady on computer"
        className={classes.img}
      />
      <motion.img
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 2, delay: 1 } }}
        src={matchesSM ? grandma5M : grandma5}
        alt="grandma on phone"
        className={classes.img}
      />
    </>
  );

  return (
    <Grid ref={ref} container direction={matchesSM ? 'column' : 'row'} className={classes.wrapper}>
      {inView ? renderer : null}
    </Grid>
  );
};

export default PhotoCollage4;
